import { withFeatureFlag } from '../../../components/FeatureFlagGate/withFeatureFlag';
import { FEATURE_FLAGS } from '../../../config/featureFlags';

/**
 * Wraps every Student Life > Parking route so a direct URL cannot reach a parking page while
 * the student_life_parking flag is off. See withFeatureFlag for the loading/redirect behavior.
 */
export const withParkingFeatureFlag = (Component) =>
    withFeatureFlag(Component, FEATURE_FLAGS.STUDENT_LIFE_PARKING);

export default withParkingFeatureFlag;
